import { policiesClient } from '../../api/clients';
import getPolicySettings from './get-policy-settings/get-policy-settings-service';
import setPolicySettings from './set-policy-settings/set-policy-settings';

const policySettingsService = {
  getPolicySettings: getPolicySettings(policiesClient),
  setPolicySettings: setPolicySettings(policiesClient),
};

export default policySettingsService;
